import CascadingElements from "@/modules/cascading/views/CascadingElements.vue";

export default [

    {
        path: '/cascading/elements/:element_id(\\d+)?/:parent_id(\\d+)?',
        name: 'CascadingElements',
        component: CascadingElements,
        meta: {title: 'Каскадирование'}
    },

]
